import './utils/jqueryLoader.js'
import React, { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ReactGA from "react-ga4";
import ReactPixel from 'react-facebook-pixel';

const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
};
//Anterior
//ReactPixel.init('864551054974472', options);
// Nueva
ReactPixel.init('973002320441100', options);

//Anterior Google Analitics Tag 09/10/2023, Actuliza Marco. 
//ReactGA.initialize("G-D1G6CRGXPH");
// ReactGA.initialize("GTM-K5PNLWC3");
//
// ReactGA.initialize([
//     {
//         trackingId: "GTM-K5PNLWC3",
//         gaOptions: {
//             'debug_mode':false
//         }, // optional
//         gtagOptions: {
//             'debug_mode':false
//         }, // optional
//     }
// ]);

// --- TikTok Pixel Loader e Inicialización ---
function initTikTokPixel(pixelId) {
    if (typeof window === 'undefined') return;
    if (window.__ttqLoaded) return;

    (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = [
            "page","track","identify","instances","debug","on","off","once","ready",
            "alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"
        ];
        ttq.setAndDefer = function(obj, method){
            obj[method] = function(){
                obj.push([method].concat(Array.prototype.slice.call(arguments,0)))
            }
        };
        for (var i = 0; i < ttq.methods.length; i++) {
            ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function(id){
            var inst = ttq._i[id] || [];
            for (var i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(inst, ttq.methods[i]);
            }
            return inst;
        };
        ttq.load = function(e, n){
            var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = r + "?sdkid=" + e + "&lib=" + t;
            var firstScript = d.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(s, firstScript);
            ttq._i = ttq._i || {};
            ttq._i[e] = [];
            ttq._i[e]._u = r;
            ttq._t = ttq._t || {};
            ttq._t[e] = +new Date();
            ttq._o = ttq._o || {};
            ttq._o[e] = n || {};
        };
    })(window, document, 'ttq');

    // Carga del pixel
    window.ttq.load(pixelId);
    window.__ttqLoaded = true;
}


// Inicializar TikTok Pixel antes del render
initTikTokPixel('D2JJLIJC77U7BITDHG4G');

// Si arrancamos o refrescamos en /sign-up, enviar un page() para anclar la sesión antes del track del componente
if (typeof window !== 'undefined' && window.ttq && window.location?.pathname === '/sign-up') {
    try { window.ttq.page(); } catch (e) {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
            <App />
        </BrowserRouter>  
);
